import stringsIT from './strings-it.json';
import stringsEN from './strings-en.json';
import stringsDE from './strings-de.json';
import stringsES from './strings-es.json';
import stringsFR from './strings-fr.json';
import stringsNL from './strings-nl.json';
import stringsSK from './strings-sk.json';
import stringsPT from './strings-pt.json';
import stringsPL from './strings-pl.json';
import stringsCS from './strings-cs.json';

import stringsXamarinEN from '@/../xamarin-translations/json/en-US.json';
import stringsXamarinIT from '@/../xamarin-translations/json/it.json';
import stringsXamarinDE from '@/../xamarin-translations/json/de.json';
import stringsXamarinES from '@/../xamarin-translations/json/es.json';
import stringsXamarinFR from '@/../xamarin-translations/json/fr.json';
import stringsXamarinNL from '@/../xamarin-translations/json/nl.json';
import stringsXamarinSK from '@/../xamarin-translations/json/sk.json';
import stringsXamarinPT from '@/../xamarin-translations/json/pt.json';
import stringsXamarinPL from '@/../xamarin-translations/json/pl.json';
import stringsXamarinCS from '@/../xamarin-translations/json/cs.json';

const strings = {
  it: { ...stringsIT, ...stringsXamarinIT },
  en: { ...stringsEN, ...stringsXamarinEN },
  de: { ...stringsDE, ...stringsXamarinDE },
  es: { ...stringsES, ...stringsXamarinES },
  fr: { ...stringsFR, ...stringsXamarinFR },
  nl: { ...stringsNL, ...stringsXamarinNL },
  sk: { ...stringsSK, ...stringsXamarinSK },
  pt: { ...stringsPT, ...stringsXamarinPT },
  pl: { ...stringsPL, ...stringsXamarinPL },
  cs: { ...stringsCS, ...stringsXamarinCS },
};

export default strings;
